
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/repayments",
      function () {
        return require("private-next-pages/admin/repayments/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/repayments"])
      });
    }
  